import { BackgroundImage } from "@organic-return/foundation-react/src/components/Media";
import { graphql, Link } from "gatsby";
import React from "react";

const TextBlockWithEmbed = (props: any) => {
    
    const isUrlAbsolute = (url: string) => url.indexOf("://") > 0 || url.indexOf("//") === 0

    const generateLink = (url: string, target: string | undefined, text: string) => {

        const linkClass = "inline-block mt-4 lg:mt-8 px-8 py-3 border border-transparent text-center md:text-left text-base leading-6 font-medium text-button-text bg-button-bg";

        if (isUrlAbsolute(url) === false) {
            return (
                <Link
                    to={url}
                    title={text}
                    target={target}
                    className={linkClass}
                >
                    {text}
                </Link>
            )
        } else {
            // else use anchor tag
            return (
                <a
                    href={url}
                    title={text}
                    target={target}
                    className={linkClass}
                >
                    {text}
                </a>
            )
        }
    }

    const textWrapperClass = `w-full lg:w-6/12 order-last ${props.embedPosition === "right" ? "lg:order-first" : "lg:order-last"}`
    const embeddedWrapperClass = `w-full lg:w-6/12 order-first ${props.embedPosition === "right" ? "lg:order-last" : "lg:order-first"}`

    let txtBlockWithEmbed = (
        <div className="text-block-embed relative w-full max-w-screen-xl mx-auto flex flex-col lg:flex-row lg:items-center gap-1 md:gap-8 xl:gap-16 px-2 py-10">
            <div className={`flex flex-col items-center md:items-start ${textWrapperClass}`}>
                {props.tagline &&
                    <span className="hidden lg:block text-accent font-bold text-left uppercase mb-2 lg:mb-4 self-start">
                        {props.tagline}
                    </span>
                }
                {props.title &&
                    <h2 className="text-3xl lg:text-4xl text-center md:text-left tracking-wide lg:leading-tight">
                        {props.title}
                    </h2>
                }
                {props.content &&
                    <div dangerouslySetInnerHTML={{ __html: props.content }}
                        className="mt-2 lg:mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed"></div>
                }
                {props.primaryButton &&
                    generateLink(
                        props.primaryButton.url,
                        undefined,
                        props.primaryButton.title
                    )
                }
            </div>
            <div className={`${embeddedWrapperClass}`}>
                {props.tagline &&
                    <span className="block lg:hidden text-accent font-bold text-left uppercase mb-2 lg:mb-4">
                        {props.tagline}
                    </span>
                }
                <div className={`flex flex-row justify-center items-center w-full`} dangerouslySetInnerHTML={{ __html: props.embed }}></div>
            </div>
        </div>
    )

    props.backgroundImage && (
        txtBlockWithEmbed = (<BackgroundImage src={props.backgroundImage.url}>{txtBlockWithEmbed}</BackgroundImage>)
    )

    return (
        <>{txtBlockWithEmbed}</>
    )
}

export default TextBlockWithEmbed

export const query = graphql`
fragment DrupalTextBlockWithEmbedContent on DrupalTextBlockWithEmbed {
    id
    backgroundImage {
        url
    }
    content
    embed
    embedPosition
    primaryButton {
        title
        url
    }
    tagline
    title
}
`